import React from 'react';
import { BsCopy } from "react-icons/bs";
import './TransactionDetail.scss';
import UploadInterface from './UploadInterface';

const TransactionDetail = () => {
  return (
    <div className="combined-interface">
      <div className="transaction-detail-background">
        <div className="transaction-detail">
          <div className="detail-row">
            <span className="label">order number</span>
            <span className="value">2024022417094511878 <BsCopy className="icon" /></span>
          </div>  
          <hr />    
          <div className="detail-row">
            <span className="label">order time</span>
            <span className="value">2024-02-24 17:09:45</span>
          </div> 
          <hr />   
          <div className="detail-row">
            <span className="label">order amount</span>
            <span className="value">111.00 (unit price:1.00)</span>
          </div>
        </div>
        <div className="upload-interface-container">
          <UploadInterface />
        </div>
      </div>
    </div>
  );
};

export default TransactionDetail;
